import styles from './OptionWithHint.module.css';

type Props = {
  value: React.ReactNode;
  hint?: string;
};

export function OptionWithHint({ value, hint }: Props) {
  return (
    <div className={styles.OptionWithHint}>
      <div className="truncate">{value}</div>
      {hint && <div className={styles.OptionWithHint_hint}>{hint}</div>}
    </div>
  );
}
